import { render } from "./StyleSeriesTile.vue?vue&type=template&id=2856d378&scoped=true"
import script from "./StyleSeriesTile.vue?vue&type=script&lang=js"
export * from "./StyleSeriesTile.vue?vue&type=script&lang=js"

import "./StyleSeriesTile.vue?vue&type=style&index=0&id=2856d378&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2856d378"]])

export default __exports__